<template>
	<div>
		<div v-show="type === 'home'" class="header-tab">
			<div class="home-logo"><img :src="require('../assets/main_btn_menu1.png')"/></div>
			<div class="user-info" v-if="userInfo">
				<img class="avatar" :src="require('../assets/roles/bg_avatar_default.png')"/>
				<span>IGG ID : {{userInfo.iggid}}</span>
				<i @click="layoutFn" class="layout_icon"><img :src="require('../assets/layout_icon.png')"/></i>		
			</div>
		</div>
		<div v-show="type === 'edit'" class="header-tab center">
			<i @click="goHome" class="el-icon-arrow-left"></i>
			<span>{{title}}</span>
		</div>
		<div v-show="type === 'bookItem'" class="header-tab center red-color">
			<i @click="goHome" class="el-icon-s-home"></i>
			<span>{{title}}</span>
		</div>
		<div v-show="type === 'dialog'" class="header-tab red-color">
			<i @click="goSave" class="el-icon-arrow-left"></i>
			<em @click="goSave" class="text-left title-color">{{leftText}}</em>
			<em @click="goPreview" class="text-right title-color">{{rightText}}</em>
		</div>
		<div v-show="type === 'branchDialog'" class="header-tab red-color">
			<i class="el-icon-news" @click="saveBranchDialog"></i>
			<em class="text-left title-color news-title">{{title}}</em>
		</div>
		<div v-show="type === 'roles'" class="header-tab center red-color">
			<i @click="goback" class="el-icon-arrow-left"></i>
			<span>{{title}}</span>
		</div>
	</div>
</template>

<script>
	import {mapMutations} from 'vuex'
	export default {
		props: ['type','userInfo'],
		data() {
			return {
				islogin: Boolean,
				leftText: 'Exit & Save',
				rightText: 'Preview',
			}
		},
		computed: {
			title() {
				if(this.type === 'edit') {
					return 'My Book Info'
				}
				if(this.type === 'bookItem') {
					return 'Book Info'
				} 
				if(this.type === 'branchDialog') {
					return this.$route.query.option
				} 
				if(this.type === 'roles') {
					return 'Create Roles'
				}
			},
			uploadData() {
				return this.$store.state.dialog.uploadData
			}
		},
		methods: {
			goback() { //提交完添加角色以后跳转回上一页 - 对话列表页面
				this.$router.go(-1)
			},
			goHome() {
				localStorage.removeItem('role_list')
				this.$router.push({
					name: 'Home',
				});
			},
			layoutFn() {
				Passport.logout(function() {
					location.reload()
				})
			},
			goSave() {
				this.$store.commit('dialog/getLocalStorgeDataFn')
				this.$store.commit('dialog/removeLocalStorgeData')
				if (!this.uploadData) {
					this.$router.push({
						name: 'BookItem',
						query: {
							book_id: this.$route.query.book_id
						}
					});
					return false
				}
				// 如果对话为空数组，直接跳转到书本详情  情况：假如用户删除了所有的对话，提交的是空数组的情况下
				this.uploadData.forEach((item,index) => {
					const Jtem = (({dialog_number,id,image,image_md5,option_list,parent_dialog,role,title,type}) =>
								 ({dialog_number,id,image,image_md5,option_list,parent_dialog,role,title,type}))(item)
					this.uploadData[index] = Jtem	
				})
				this.uploadData.forEach(item => {
					if(item.type === 3) {
						item.option_list.forEach((Jtem,index) => {
							const Ztem = (({jump,option}) =>
										 ({jump,option}))(Jtem)
							item.option_list[index] = Ztem
						})
						// item.option_list = JSON.stringify(item.option_list)
					}	
				})
				const book_id = parseInt(this.$route.query.book_id), chapter_number = parseInt(this.$route.query.chapter_number), update_version = parseInt(this.$route.query.version)
				this.postAxios('/h5/saveWriterDialog', {book_id:book_id, chapter_number:chapter_number, update_version: update_version, dialog_content: JSON.stringify(this.uploadData)}).then((data) => {
				  if (data.code === 200) {
					this.$router.push({
						name: 'BookItem',
						query: {
							book_id: this.$route.query.book_id
						}
					});	
				  }
				}, (err) => {
				  // handle authorization error
				}); 
			},
			goPreview() {
				this.$store.commit('dialog/getLocalStorgeDataFn')
				if(!this.uploadData) {
					return
				} else {
					localStorage.setItem('previewData',JSON.stringify(this.uploadData))
					this.$router.push({
						name: 'Preview',
						query: {
							book_id: this.$route.query.book_id,
							chapter_number: this.$route.query.chapter_number,
							update_version: this.$route.query.update_version
						}		
					});
				}
			},
			saveBranchDialog() {
				// this.$route.query.search_key 用于判断是否在分支对话内
				if (this.$route.query.search_key) {
					this.$router.go(-1)
				} else {
					this.$store.commit('dialog/clearDialogList', 'option_1_dialogList')
					this.$router.push({
						name: 'Dialog',
						query: {
							book_id: this.$route.query.book_id,
							chapter_number: this.$route.query.chapter_number,
							update_version: this.$route.query.update_version,
						}
					});
				}
			}
		}
	}
</script>

<style lang="scss">
	.branch-title {
		text-align: center;
		padding: 10px 0;
		border-bottom: 1px solid #ca2b44;
		font-size: 16px;
		font-weight: bold;
		background-color: #fa4763;
		color: #fff;    
	}
	.header-tab {
		width: 640px;
		margin: 0 auto;
		color: #202020;
		font-size: 20px;
		font-weight: bold;
		height: 60px;
		line-height: 60px;
		position: relative;
		font-family: 'DIN Bold';
		border-bottom: 1px solid #dcdcdc;
		.home-logo {
			img {
				height: 30px;
				margin: 15px 0 0 10px;    
			}
		}
		.el-dropdown-link {
		    cursor: pointer;
		    color: #409EFF;
		}
		.el-icon-arrow-down {
		    font-size: 12px;
		}
		&.red-color {
			color: #fa4764;
		}
		&.center {
			text-align: center;
		}
		i.el-icon-arrow-left,i.el-icon-news {
			position: absolute;
			left: 0;
			top: 0;
			line-height: 60px;
			font-size: 24px;
			font-weight: bold;
		}
		i.el-icon-s-home {
			position: absolute;
			left: 0;
			top: 0;
			color: #fff;
			background: #fd6969;
			line-height: 20px;
			font-size: 20px;
			padding: 5px;
			margin: 15px 0 0 20px;
			border-radius: 50px;  
			&:hover {
				cursor: pointer
			}
		}
		i.el-icon-news {
			left: 20px;
		}
		.user-info {
			position: absolute;
			right: 0;
			top: 0;
			display: flex;
			color: #4c4c4c;
			align-items: center;
			span {
				font-size: 16px;
			}
			img.avatar {
				height: 30px;
				margin-right: 10px;
			}
			i.layout_icon {
				padding: 0 10px;
				cursor: pointer;
				font-weight: bold;
				color:#bdbdbd;
				img {
					height: 16px;
				}
				&:hover {
					color: #fa4764
				}
			} 
		}

		em.text-left {
			float: left;
			padding-left: 40px;
		}
		em.news-title {
			padding-left: 60px;
		}
		em.text-right {
			float: right;
		}
		
		em.text-center {
			float: right;
		}

		.title-color {
			cursor: pointer;
		}
	}
</style>
